import React from 'react'

const Position = () => {
  return (
    <div className="position">
        <div className="program_right_svg">
            <h3 className="h3mb">내가 지원한 포지션</h3>
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="XFteHAoEX_O2i2sztwAI"><path d="M9 16.34l4.58-4.59L9 7.16l1.41-1.41 6 6-6 6z" fillRule="evenodd"></path></svg>
        </div>
        <div className="position_inner">
            <img alt="빈 아이콘" data-src="https://d1nuzc1w51n1es.cloudfront.net/e05ed52efe7e63c4122e.png" data-srcset="" className="RU5SuJ6575FzbRUXqWlr" src="https://d1nuzc1w51n1es.cloudfront.net/e05ed52efe7e63c4122e.png" srcSet="" />
            <p>새로운 채용 공고가 있어요!<br /> 요즘 뜨는 포지션 보러 갈까요?</p>
            <span className="btn1">포지션 찾아보기</span>
        </div>
        <div className="position_bottom">
            <h3 className="h3mb pt">지원하고 싶은 공고를 찾아보세요.</h3>
            <div className="position_box">
                <div className="position_box-1" >
                    <div className="position_box-img" style={{backgroundColor: 'rgb(255, 243, 224)'}}>
                        <img alt="신입 연봉 4천 이상" data-src="https://asset.programmers.co.kr/image/origin/production/job_theme/162887/ca476513-5294-4d15-87da-b6df56e4fa15.png" data-srcset="" className="" src="https://asset.programmers.co.kr/image/origin/production/job_theme/162887/ca476513-5294-4d15-87da-b6df56e4fa15.png" srcSet="" />
                    </div>
                    <h3 className="h3mb">신입 연봉 4천 이상</h3>
                </div>
                <div className="position_box-1" >
                    <div className="position_box-img" style={{backgroundColor: 'rgb(224, 242, 241)'}}>
                        <img alt="병역특례" data-src="https://asset.programmers.co.kr/image/origin/production/job_theme/163050/adbe59c6-385f-4283-822f-68f76ede9797.png" data-srcset="" className="" src="https://asset.programmers.co.kr/image/origin/production/job_theme/163050/adbe59c6-385f-4283-822f-68f76ede9797.png" srcSet="" />
                    </div>
                    <h3 className="h3mb">병역특례</h3>
                </div>
                <div className="position_box-1" >
                    <div className="position_box-img" style={{backgroundColor: 'rgb(251, 233, 231)'}}>
                        <img alt="시리즈 투자" data-src="https://asset.programmers.co.kr/image/origin/production/job_theme/162890/595df8b9-616a-40a5-a7d6-9ac073328287.png" data-srcset="" className="" src="https://asset.programmers.co.kr/image/origin/production/job_theme/162890/595df8b9-616a-40a5-a7d6-9ac073328287.png" srcSet="" />
                    </div>
                    <h3 className="h3mb">시리즈 투자</h3>
                </div>
                <div className="position_box-1" >
                    <div className="position_box-img" style={{backgroundColor: 'rgb(232, 245, 233)'}}>
                        <img alt="리모트 근무" data-src="https://asset.programmers.co.kr/image/origin/production/job_theme/162891/b5c3c39e-f3c3-409a-8faf-bdc8521ab736.png" data-srcset="" className="" src="https://asset.programmers.co.kr/image/origin/production/job_theme/162891/b5c3c39e-f3c3-409a-8faf-bdc8521ab736.png" srcSet="" />
                    </div>
                    <h3 className="h3mb">리모트 근무</h3>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Position
